import { readCollectionId, readDeviceUuid } from './storage';

declare global {
  interface Window {
    StaySignals?: {
      /** `null` when init hasn't completed or failed. Empty string is never returned. */
      getCollectionId(): string | null;
      /** Always returns a value — mints + persists on first call if needed. */
      getDeviceUuid(): string;
    };
  }
}

/** Attach the minimal global surface. Safe to call multiple times; later calls overwrite. */
export function installGlobals(): void {
  window.StaySignals = Object.freeze({
    getCollectionId: () => readCollectionId(),
    getDeviceUuid: () => readDeviceUuid(),
  });
}
